import React from 'react'
import { Breadcrumb, Heading, Divider } from '../../components/common/atoms'
import {popup_close as closebtn} from '../../assets/images'

const EmployeeDataHoc = ({title, liner, breadcrumb, close, children, classes}) => {
  return (
    <div className={`p-8 bg-gray-100 min-h-screen ${classes}`}>
      <img src={closebtn} alt='close-btn' className='absolute right-8 cursor-pointer h-8 w-8' onClick={close} />

      <Breadcrumb list={breadcrumb} classes='mb-2 mt-0' />
      <Heading mainHeading={title} mainClasses='font-fig-extrabold text-3xl font-medium leading-tight tracking-tight text-gray-900 sm:text-4xl' />
      <p className='mb-0 text-gray-600 mt-1'>{liner}</p>
      <Divider classes='w-full mt-6' />
      {children}
    </div>
  )
}

export default EmployeeDataHoc